export default __webpack_public_path__ + "c207fb7c692c1200e8071b4cab0fe0f9.png";